import { AbstractControl, ValidatorFn } from '@angular/forms';
import { intersection, range } from 'lodash';

export class ClassValidator {
  static rangePattern = /^0*(\d+)-0*(\d+)/;

  static leadingZerosPattern = /^0*/;

  static classesValidator(data: string[]): ValidatorFn {
    const matchValidNumPattern = /^0*(\d+$)/;

    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.errors) {
        control.clearValidators();
      }
      const enteredData = control.value.trim().match(matchValidNumPattern);
      const rangeMatch: RegExpExecArray | null =
        ClassValidator.rangePattern.exec(control.value);

      if (rangeMatch) {
        const fromNumber = Number(rangeMatch[1]);
        const toNumber = Number(rangeMatch[2]);
        if (
          fromNumber >= toNumber ||
          ClassValidator._isValidNumber(fromNumber) ||
          ClassValidator._isValidNumber(toNumber)
        ) {
          return { notValid: true };
        }
        const numberArray = range(fromNumber, toNumber + 1);
        const duplicateEntries: number[] = intersection(
          numberArray,
          data.map((o) => Number(o)),
        );
        if (duplicateEntries.length > 0) {
          return { duplicate: true };
        }
      } else if (enteredData) {
        const entVal = enteredData[1];
        if (data.includes(entVal)) {
          return { duplicate: true };
        } else if (ClassValidator._isValidNumber(entVal)) {
          return { notValid: true };
        }
      } else if (control.value.trim()) {
        return { notValid: true };
      }
      return null;
    };
  }

  private static _isValidNumber(num: number): boolean {
    return num < 1 || num > 45 ? true : false;
  }
}
